import { ORDER_FEE_RATE_POLLING_INTERVAL } from 'config'
import { useEffect } from 'react'
import { useAppDispatch } from 'store'
import { useAccountInfo } from 'store/account/hooks'
import { useInterval } from 'usehooks-ts'
import { getPerpFeeRateAction } from './actions/getPerpFeeRateActions'
import { getPerpPositionsAction } from './actions/getPerpPositionsActions'
import { getPerpOpenOrdersAction } from './actions/getPerpOpenOrdersActions'
import { useFetchMarketPriceConfig } from 'store/spot/updater'

function usePollingPerpFeeRate() {
  const dispatch = useAppDispatch()

  const { userId = 0 } = useAccountInfo()
  useEffect(() => {
    if (!userId) return
    dispatch(getPerpFeeRateAction())
  }, [userId])
  useInterval(
    () => {
      dispatch(getPerpFeeRateAction())
    },
    userId ? ORDER_FEE_RATE_POLLING_INTERVAL : null,
  )
}

export function useFetchPerpOpenOrders() {
  const dispatch = useAppDispatch()
  const { userId = 0, accountId = 0 } = useAccountInfo()
  useEffect(() => {
    if (!userId) return
    dispatch(getPerpOpenOrdersAction(accountId))
  }, [userId, accountId])
  // useInterval(
  //   () => {
  //     dispatch(getPerpOpenOrdersAction(accountId))
  //   },
  //   userId ? ACCOUNT_INFO_POLLING_INTERVAL : null
  // )
}

export function useFetchPerpPositions() {
  const dispatch = useAppDispatch()
  const { userId = 0, accountId = 0 } = useAccountInfo()
  useEffect(() => {
    if (!userId) return
    dispatch(getPerpPositionsAction())
  }, [userId, accountId])
  // useInterval(
  //   () => {
  //     dispatch(getPerpOpenOrdersAction(accountId))
  //   },
  //   userId ? ACCOUNT_INFO_POLLING_INTERVAL : null
  // )
}

export default function Updater() {
  usePollingPerpFeeRate()
  useFetchPerpOpenOrders()
  useFetchPerpPositions()
  useFetchMarketPriceConfig()

  return null
}
